module.exports = require("./ii-CN.js");